import Header from "@/reusable_sections/Header";
import Footer from "@/reusable_sections/Footer";
import PolicyLayout, { PolicySection } from "@/components/common/PolicyLayout";
export default function PrivacyPage() {
  return <div>
      <Header />
      <PolicyLayout title="Privacy Policy" intro="This Privacy Policy explains how AQUAFLAME collects, uses, and protects your personal information when you browse our website or make a purchase." updated="October 2026">
        <PolicySection title="1. Who We Are">
          <p>
            AQUAFLAME is an online retailer of residential natural gas water heaters and parts, operated by Domain Technology (Hong Kong) Co., Limited.
          </p>
          <p>
            Company address: Man On Building, 18–20 Ho Man Tin Street, Kowloon City District, Kowloon, Hong Kong.
          </p>
          <p>
            Contact email:{" "}
            <a href="mailto:carry6891@outlook.com">carry6891@outlook.com</a>. We reply to emails within 1–2 business days.
          </p>
        </PolicySection>

        <PolicySection title="2. Information We Collect">
          <p>
            We collect personal information that you provide directly to us when using our store, including:
          </p>
          <ul>
            <li>Contact details such as your name, email address, billing address, and shipping address.</li>
            <li>Phone number, if you choose to provide one for delivery updates or order questions.</li>
            <li>Order information, including products purchased, order totals, and transaction records.</li>
            <li>Account details, such as your username and password, if you register an account with us.</li>
            <li>Customer communications, including messages, inquiries, and emails you send to us.</li>
            <li>
              Basic technical information collected automatically when you visit our website, such as your browser type, device details, IP address, and pages visited.
            </li>
          </ul>
        </PolicySection>

        <PolicySection title="3. Payment Information">
          <p>
            Payment transactions are processed directly by our external payment service providers. Your full credit or debit card details are submitted securely to these providers and are never stored or processed on our servers.
          </p>
        </PolicySection>

        <PolicySection title="4. How We Use Your Information">
          <p>We use the information we collect for the following purposes:</p>
          <ul>
            <li>To process, fulfill, and ship your orders across the United States.</li>
            <li>To communicate with you regarding your orders, tracking information, and customer support inquiries.</li>
            <li>To maintain and manage your account.</li>
            <li>To prevent fraud, verify transactions, and protect the security of our store.</li>
            <li>To comply with applicable legal, accounting, and regulatory obligations.</li>
          </ul>
        </PolicySection>

        <PolicySection title="5. Information Sharing and Disclosure">
          <p>
            We do not sell your personal information. We may share necessary information with trusted third parties solely to operate our store and fulfill our commitments to you:
          </p>
          <ul>
            <li>Payment processors to authorize and complete transactions.</li>
            <li>Shipping carriers and logistics partners to deliver your purchases.</li>
            <li>Service providers who assist with website hosting, database management, and email communications.</li>
            <li>Public authorities or legal bodies when required to do so by applicable law or a valid legal request.</li>
          </ul>
        </PolicySection>

        <PolicySection title="6. Cookies and Tracking Technologies">
          <p>
            We use essential cookies and similar browser storage technologies to maintain shopping cart contents, keep you signed in to your account, and enable core store functions. You can manage or disable cookies through your browser settings, though disabling essential cookies may impact your ability to use the site or complete an order.
          </p>
        </PolicySection>

        <PolicySection title="7. Data Retention">
          <p>
            We retain personal information for as long as necessary to fulfill the purposes described in this policy, including completing transactions, resolving disputes, providing customer support, and complying with statutory tax and accounting obligations.
          </p>
        </PolicySection>

        <PolicySection title="8. Your Choices and Rights">
          <p>
            You have the right to request access to the personal information we hold about you, to request corrections to inaccurate details, or to request the deletion of your personal data, subject to any legal obligations requiring us to retain specific records.
          </p>
          <p>
            To exercise any of these choices, please email us at{" "}
            <a href="mailto:carry6891@outlook.com">carry6891@outlook.com</a>. We reply to emails within 1–2 business days.
          </p>
        </PolicySection>

        <PolicySection title="9. Data Security">
          <p>
            We implement reasonable organizational and technical safeguards designed to protect your personal information against unauthorized access, loss, alteration, or misuse. However, no method of electronic transmission over the internet or data storage is 100% secure, and we cannot guarantee absolute security.
          </p>
        </PolicySection>

        <PolicySection title="10. Children's Privacy">
          <p>
            Our website and products are intended for adult purchasers. We do not knowingly collect personal information from individuals under the age of 18. If you believe a child has provided us with personal information, please contact us so we can promptly delete it.
          </p>
        </PolicySection>

        <PolicySection title="11. Changes to This Privacy Policy">
          <p>
            We may update this Privacy Policy from time to time to reflect operational, legal, or regulatory updates. Any revisions will be published on this page with an updated revision date.
          </p>
        </PolicySection>

        <PolicySection title="12. Contact Us">
          <p>
            If you have questions or concerns about this Privacy Policy or how your personal information is handled, please contact:
          </p>
          <p>
            Domain Technology (Hong Kong) Co., Limited<br />
            Man On Building, 18–20 Ho Man Tin Street<br />
            Kowloon City District, Kowloon, Hong Kong<br />
            Email: <a href="mailto:carry6891@outlook.com">carry6891@outlook.com</a>
          </p>
          <p>We reply to emails within 1–2 business days.</p>
        </PolicySection>
      </PolicyLayout>
      <Footer />
    </div>;
}